import { inject, Injectable } from '@angular/core';

import { Apollo } from 'apollo-angular';
import { map } from 'rxjs';

import { GET_COUNTRY } from 'src/app/@graphql/operations/query';
import { ApiService } from 'src/app/@graphql/services/api.service';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';

@Injectable({
  providedIn: 'root',
})
export class CountriesService extends ApiService {
  private readonly cookieAuthService = inject(CookieAuthService);

  constructor() {
    super(inject(Apollo));
  }

  listCountries() {
    const companyObject = this.cookieAuthService.getCompanyObject;
    const company = companyObject?.Id_company;
    return this.query(GET_COUNTRY, { company }).pipe(
      map((result) => {
        return result.getAllCountries;
      }),
    );
  }
}
